<template>
  <div
    class="content"
    :class="{ 'h5-organization-courses': isH5, 'organization-courses': !isH5 }"
  >
    <div class="filter-wrap">
      <div class="type-list">
        <span
          @click="handleTypeChange(item.type)"
          v-for="item in typeList"
          :key="item.type"
          :class="{ 'is-active': type === item.type }"
          class="type-item"
          >{{ item.name }}</span
        >
      </div>
      <el-dropdown @command="handleMenuBehavior" trigger="click">
        <span class="el-dropdown-link">
          {{ sortLabel }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="opt in sortOptions"
            :key="opt.value"
            :command="opt.value"
            :class="{ 'is-active': order_by === opt.value }"
          >{{ opt.label }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 列表 -->
    <div class="content-wrap" v-if="courseList.length">
      <div v-for="item in courseList" :key="item.id" class="item-wrap">
        <p v-if="isH5" class="h5-org-name">
          {{ item.org_name }}
        </p>
        <CourseCard
          class="h5-course-card"
          v-if="isH5"
          :courseInfo="item"
          type="big"
        />
        <CourseCard
          class="org-course-card"
          v-else
          :courseInfo="item"
          :showOrgName="!$route.query.org_id"
          type="small"
        />
      </div>
    </div>
    <el-empty
      v-else
      description="暂无内容"
      :image="require('@/assets/img/live-list/empty.png')"
    ></el-empty>
  </div>
</template>

<script>
import { EventBus } from "@saas/components/src/utils/event-bus";
import { getCourseList } from "@saas/service-api/src/course";
import { CourseCard, isH5 } from "@saas/components/src";
export default {
  data: function () {
    return {
      keyword: "",
      type: 0,
      courseList: [],
      page_no: 1,
      page_size: 18,
      order_by: "0",
      sortOptions: [
        { value: "0", label: "推荐排序" },
        { value: "1", label: "价格从低到高" },
        { value: "2", label: "价格从高到低" },
        { value: "3", label: "报名人数从少到多" },
        { value: "4", label: "报名人数从多到少" },
      ],
      noMore: false, //没有更多
      loading: false, //加载数据中
      isH5: isH5(),
      typeList: [
        {
          type: 0,
          name: "全部",
        },
        {
          type: 1,
          name: "免费",
        },
        {
          type: 2,
          name: "收费",
        },
      ],
    };
  },
  mounted() {
    this.inintData();
    window.addEventListener("scroll", this.scrollFn, true); //监听页面滚动
    EventBus.$off("keyword");
    EventBus.$on("keyword", (msg) => {
      if (msg != this.keyword) {
        this.keyword = msg;
        this.page_no = 1;
        this.apiGetCourseList();
      }
    });
  },
  watch: {},
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollFn, true); //销毁滚动事件
  },
  methods: {
    inintData() {
      if (this.$route.query.keyword) {
        this.keyword = this.$route.query.keyword;
        // 清空参数
        this.$route.query.keyword = "";
      }
      this.apiGetCourseList();
    },
    handleMenuBehavior(command) {
      this.page_no = 1;
      this.order_by = command;
      this.apiGetCourseList();
    },
    apiGetCourseList() {
      this.loading = true;
      let params = {
        page_no: this.page_no,
        page_size: this.page_size,
        org_id: "",
        course_name: this.keyword,
        fee_type: this.type || "",
        order_by: Number(this.order_by) || "",
      };
      getCourseList(params)
        .then((res) => {
          if (res.code === 1) {
            if (res.data && res.data.list) {
              if (params.page_no === 1) {
                this.courseList = res.data.list;
              } else {
                this.courseList = this.courseList.concat(res.data.list);
              }
              if (this.courseList.length === res.data.total) {
                this.noMore = true;
              } else {
                this.noMore = false;
              }
            }
          } else {
            this.$message.error(res.message);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onSearch() {
      this.page_no = 1;
      this.apiGetCourseList();
    },
    handleTypeChange(type) {
      this.type = type;
      this.page_no = 1;
      this.apiGetCourseList();
    },
    scrollFn() {
      if (this.loading) return false;
      //获取网页的总高度
      var htmlHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;
      //clientHeight是网页在浏览器中的可视高度
      var clientHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      //scrollTop是浏览器滚动条的top位置
      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      //判断到底部了
      if (scrollTop + clientHeight > htmlHeight - 100) {
        if (!this.noMore) {
          this.page_no++;
          this.apiGetCourseList();
        }
      }
    },
  },
  computed: {
    sortLabel() {
      const opt = this.sortOptions.find((o) => o.value === this.order_by);
      return opt ? opt.label : "排序";
    },
  },
  components: {
    CourseCard,
  },
};
</script>

<style lang="scss" scoped>
.organization-courses {
  max-width: 768px;
  width: 100%;
  padding-top: 20px;
  background: var(--page-bg);
  color: var(--text-primary);
  .filter-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 0 16px 0 10px;
    border-bottom: 1px solid var(--user-btn-border);
  }
  .type-item {
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
    color: var(--text-secondary);
    line-height: 20px;
    padding: 6px;
    margin-right: 36px;
  }
  .is-active {
    position: relative;
    font-size: 14px;
    color: var(--text-primary);
    line-height: 20px;
    &::after {
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      display: block;
      content: "";
      width: 28px;
      height: 2px;
      background: $saas-theme-color;
    }
  }
  .el-dropdown-link {
    font-size: 14px;
    color: var(--text-primary);
    line-height: 20px;
  }
  .content-wrap {
    display: flex;
    flex-wrap: wrap;
  }
  .item-wrap {
    margin-right: 24px;
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
  .org-course-card {
    width: 240px;
    ::v-deep .cover {
      height: 135px !important;
    }
  }
}

.h5-organization-courses {
  background: var(--page-bg);
  color: var(--text-primary);
  width: 100%;
  .filter-wrap {
    padding: 0.29rem 0.43rem 0;
    display: flex;
    justify-content: space-between;
    border-bottom: 0.01rem solid var(--user-btn-border);
    .type-item {
      display: inline-block;
      font-size: 0.37rem;
      line-height: 0.53rem;
      color: var(--text-secondary);
      padding-bottom: 0.27rem;
      margin-right: 0.64rem;
    }
    .is-active {
      position: relative;
      color: var(--text-primary);
      font-size: 0.37rem;
      line-height: 0.53rem;
      &::after {
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        display: block;
        content: "";
        width: 0.75rem;
        height: 0.05rem;
        border-radius: 0.03rem;
        background: $saas-theme-color;
      }
    }
  }
  .content-wrap {
    .item-wrap {
      padding-top: 0.43rem;
    }
    .h5-org-name {
      position: relative;
      font-size: 0.43rem;
      color: var(--text-primary);
      line-height: 0.59rem;
      padding-left: 0.59rem;
      &::after {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        display: block;
        content: "";
        width: 0.11rem;
        height: 0.43rem;
        background: $saas-theme-color;
      }
    }
    .h5-course-card {
      padding: 0.32rem 0.43rem 0.43rem;
      border-bottom: 0.01rem solid var(--user-btn-border);
      margin-bottom: 0;
    }
  }
}
</style>
